export default "__VITE_ASSET__Cd0t7kPe__"